import React, { useEffect, useId, useRef, useState } from "react"
import PropTypes from "prop-types"
import { UncontrolledTooltip } from "reactstrap"

const TableTextCell = ({
  text,
  maxLines = 1,
  className = "",
  emptyText = "-",
}) => {
  const contentRef = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const tooltipId = useId().replace(/:/g, "")
  const displayText =
    text !== null && text !== undefined && String(text).trim()
      ? String(text).trim()
      : emptyText
  const showTooltip = isTruncated && displayText !== emptyText

  useEffect(() => {
    const el = contentRef.current
    if (!el) return

    const checkTruncation = () => {
      if (maxLines <= 1) {
        setIsTruncated(el.scrollWidth > el.clientWidth)
        return
      }
      setIsTruncated(el.scrollHeight > el.clientHeight + 1)
    }

    checkTruncation()

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(checkTruncation)
        : null
    resizeObserver?.observe(el)

    window.addEventListener("resize", checkTruncation)
    return () => {
      resizeObserver?.disconnect()
      window.removeEventListener("resize", checkTruncation)
    }
  }, [displayText, maxLines])

  const lineClass =
    maxLines <= 1
      ? "table-text-cell--single-line"
      : `table-text-cell--multi-line table-text-cell--lines-${Math.min(
          maxLines,
          4
        )}`

  return (
    <>
      <span
        ref={contentRef}
        id={showTooltip ? tooltipId : undefined}
        className={`table-text-cell ${lineClass}${className ? ` ${className}` : ""}`}
      >
        {displayText}
      </span>
      {showTooltip && (
        <UncontrolledTooltip placement="top" target={tooltipId}>
          {displayText}
        </UncontrolledTooltip>
      )}
    </>
  )
}

TableTextCell.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxLines: PropTypes.number,
  className: PropTypes.string,
  emptyText: PropTypes.string,
}

export default TableTextCell
